const categories = [
  {
    icon: 'ri-home-4-line',
    title: 'Residential Energy',
    description: 'Solar solutions, battery storage, EV charging, smart home energy, energy monitoring and home energy management.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Australian%20suburban%20home%20with%20sleek%20black%20solar%20panels%20on%20roof%20and%20Tesla%20Powerwall%20battery%20mounted%20on%20exterior%20wall%20electric%20vehicle%20charging%20in%20driveway%20beautiful%20garden%20landscaping%20natural%20daylight%20clean%20minimalist%20architectural%20style%20professional%20real%20estate%20photography&width=800&height=600&seq=cat-residential&orientation=landscape',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Commercial Energy',
    description: 'Commercial solar, commercial batteries, fleet charging, energy management and demand management for growing businesses.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Australian%20commercial%20office%20building%20with%20large%20solar%20panel%20array%20on%20flat%20roof%20visible%20from%20low%20angle%20blue%20sky%20with%20clouds%20professional%20commercial%20architecture%20clean%20lines%20sustainable%20business%20energy%20solution%20corporate%20photography&width=800&height=600&seq=cat-commercial&orientation=landscape',
  },
  {
    icon: 'ri-building-line',
    title: 'Industrial Energy',
    description: 'Containerised storage, microgrids, grid support, power quality and industrial monitoring for large-scale operations.',
    image: 'https://readdy.ai/api/search-image?query=Large%20industrial%20energy%20storage%20facility%20with%20containerised%20battery%20systems%20in%20neat%20rows%20modern%20industrial%20warehouse%20exterior%20with%20solar%20panels%20on%20roof%20blue%20sky%20professional%20industrial%20architecture%20clean%20geometric%20composition%20high%20quality%20photography&width=800&height=600&seq=cat-industrial&orientation=landscape',
  },
  {
    icon: 'ri-computer-line',
    title: 'Energy Software',
    description: 'Monitoring, forecasting, optimisation, asset management and future VPP participation tools for the smart grid.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20energy%20management%20dashboard%20displayed%20on%20a%20large%20floating%20screen%20showing%20real%20time%20renewable%20energy%20data%20charts%20graphs%20and%20analytics%20clean%20minimalist%20UI%20design%20with%20green%20and%20blue%20accent%20colors%20modern%20office%20setting%20soft%20lighting&width=800&height=600&seq=cat-software&orientation=landscape',
  },
  {
    icon: 'ri-team-line',
    title: 'Professional Services',
    description: 'Installation, maintenance, warranty, finance and consulting services from verified Australian providers.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Australian%20solar%20installer%20technician%20in%20safety%20gear%20working%20on%20rooftop%20solar%20panel%20installation%20with%20tools%20bright%20sunny%20day%20blue%20sky%20modern%20Australian%20suburban%20home%20clean%20professional%20composition%20service%20photography&width=800&height=600&seq=cat-services&orientation=landscape',
  },
];

export default function MarketplaceCategories() {
  return (
    <section id="marketplace" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-50 border border-secondary-200/50 text-xs font-semibold tracking-wider uppercase text-secondary-700 mb-5">
            Marketplace
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl mx-auto" style={{ color: '#111827' }}>
            Explore Renewable
            <span className="relative ml-2" style={{ color: '#37A9E0' }}>
              Energy Solutions
            </span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            Browse our marketplace categories designed for every stage of the renewable energy journey.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {categories.map((cat, i) => (
            <div
              key={cat.title}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={cat.image} alt={cat.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center mb-3 transition-colors group-hover:bg-primary-50">
                  <i className={`${cat.icon} text-primary-500 text-lg`}></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2">{cat.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{cat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}